<template>
    <BasePanel :icon="HomeIcon" :icon-bold="true" :title="$t('account_settings.dashboard')" :loading="loading">
        <BaseDoughnutChart
            v-if="ordersPerIssuer?.total_amount > 0 && chartItems"
            :total="ordersPerIssuer.total_amount"
            :total-label="$t('portfolio.investments_total')"
            :items="chartItems"
            :currency="ordersPerIssuer.currency" />
        <template v-else>
            <p class="mt-1 text-sm text-gray-500" v-html="$t('portfolio.no_investments_to_show')"></p>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
import BasePanel from '../../base/BasePanel.vue'
import BaseDoughnutChart from '../../base/BaseDoughnutChart.vue'
import { HomeIcon } from '@heroicons/vue/outline'
import { OrdersPerIssuer } from '../../../typings'
import { computed, onMounted, toRefs } from 'vue'

const props = defineProps<{
    ordersPerIssuer: OrdersPerIssuer | null
    loading: boolean
}>()

const { ordersPerIssuer } = toRefs(props)

const chartItems = computed(() => {
    if (!ordersPerIssuer.value) {
        return
    }
    return ordersPerIssuer.value.issuers.map((issuer) => {
        return {
            name: issuer.name,
            amount: issuer.total_amount,
        }
    })
})
</script>

<style scoped></style>
